module.exports = __webpack_public_path__ + "static/img/airpods_pro.6a3e533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/imgs/airpods_pro.jpg
// module id = iomH
// module chunks = 0